// Questionnaire/PsychologistsByRequest.tsx

// Добавим получение prof_level и for_whom из URL и localStorage

import React, {useCallback, useEffect} from 'react';
import {IPsychologist} from '../../Types/psychology/psychologist';
import {axios} from 'Auth/axiosConfig';
import {FCCC, FRC} from 'WideLayout/Layouts';
import FindPsychologistButtonsBox from '../FindPsychologistButtonsBox';
import {useTheme} from 'Theme/ThemeContext';
import {useLocation, useNavigate} from 'react-router-dom';
import PsychologistListWrapper from "Psychologist/PsychologistListWrapper";

interface PsychologistsByRequestProps {
    containerRef?: React.RefObject<HTMLDivElement>;
}

const PsychologistsByRequest: React.FC<PsychologistsByRequestProps> = ({containerRef}) => {
    const {plt} = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const configParam = queryParams.get('config');
        const genderPreferenceParam = queryParams.get('gender_preference');
        const isPsychologistParam = queryParams.get('is_psychologist');
        const mentalHealthParam = queryParams.get('mental_health');
        const hasChildrenParam = queryParams.get('is_psychologist_has_child');
        const specializationsParam = queryParams.get('specializations');
        const skillsParam = queryParams.get('skills');
        const reservationPaidParam = queryParams.get('reservation_paid');
        const profLevelParam = queryParams.get('prof_level');    // добавлено
        const forWhomParam = queryParams.get('for_whom');        // добавлено

        let shouldUpdate = false;

        const clientRequestStr = localStorage.getItem('clientRequest');
        const clientRequest = clientRequestStr ? JSON.parse(clientRequestStr) : {};

        if (configParam) {
            clientRequest.consultation_config = {id: parseInt(configParam)};
            queryParams.delete('config');
            shouldUpdate = true;
        }

        if (genderPreferenceParam) {
            clientRequest.gender_preference = genderPreferenceParam;
            queryParams.delete('gender_preference');
            shouldUpdate = true;
        }

        if (reservationPaidParam) {
            clientRequest.reservation_paid = reservationPaidParam;
            queryParams.delete('reservation_paid');
            shouldUpdate = true;
        }

        if (isPsychologistParam) {
            clientRequest.is_psychologist = isPsychologistParam === 'true' || isPsychologistParam === '1';
            queryParams.delete('is_psychologist');
            shouldUpdate = true;
        }

        if (mentalHealthParam) {
            clientRequest.mental_health = mentalHealthParam;
            queryParams.delete('mental_health');
            shouldUpdate = true;
        }

        if (hasChildrenParam) {
            clientRequest.is_psychologist_has_child = hasChildrenParam === 'true' || hasChildrenParam === '1';
            queryParams.delete('is_psychologist_has_child');
            shouldUpdate = true;
        }

        if (specializationsParam) {
            clientRequest.specializations = specializationsParam.split(',').map(id => parseInt(id));
            queryParams.delete('specializations');
            shouldUpdate = true;
        }

        if (skillsParam) {
            clientRequest.skills = skillsParam.split(',').map(id => parseInt(id));
            queryParams.delete('skills');
            shouldUpdate = true;
        }

        if (profLevelParam) {                    // добавлено
            clientRequest.prof_level = profLevelParam;
            queryParams.delete('prof_level');
            shouldUpdate = true;
        }

        if (forWhomParam) {                      // добавлено
            clientRequest.for_whom = forWhomParam;
            queryParams.delete('for_whom');
            shouldUpdate = true;
        }

        if (shouldUpdate) {
            localStorage.setItem('clientRequest', JSON.stringify(clientRequest));

            navigate({
                pathname: location.pathname,
                search: queryParams.toString()
            }, {replace: true});
        }

    }, [location.search, navigate, location.pathname]);

    const fetchPsychologists = useCallback(async (page: number): Promise<{
        results: IPsychologist[];
        count: number;
        next: string | null
    }> => {
        const clientRequestStr = localStorage.getItem('clientRequest');
        const clientRequest = clientRequestStr ? JSON.parse(clientRequestStr) : {};
        if (clientRequest.consultation_config) {
            clientRequest.consultation_config = clientRequest.consultation_config.id;
        }
        if (clientRequest.psychologist) {
            clientRequest.psychologist = clientRequest.psychologist.id;
        }
        console.log('Client request: ', clientRequest);
        const response = await axios.post('/api/v1/psychologists/by-request/', {
            ...clientRequest,
            page: page,
        });

        return response.data;
    }, []);

    return (
        <PsychologistListWrapper
            containerRef={containerRef}
            fetchPsychologists={fetchPsychologists}
            emptyMessage={
                <FCCC bg={plt.colors.secondary.lighter}
                      p={2} g={1} rounded={3} maxW={400} mt={2} mx={'auto'}>
                    <FRC textAlign={'center'}>
                        Тут ничего нет, и это странно напишите нам, вероятно это ошибка.
                    </FRC>
                    <FindPsychologistButtonsBox/>
                </FCCC>
            }
        />
    );
};

export default PsychologistsByRequest;
